import React from 'react'
import MSTR from './MSTR'

const Strategy = (): JSX.Element => (
  <MSTR />
)

export default Strategy
